// The wall card's fullscreen (owner 2026-10-21). Figma: header button 4317:12474 / 4317:12475, Web / Wall playback /
// Fullscreen · YouTube 4314:12567 (dark 4314:12590) with its band 4317:12486 outside the player.
import { useEffect, useState } from "react";

type FsDoc = Document & { webkitFullscreenElement?: Element | null; webkitExitFullscreen?(): Promise<void> | void };
type FsEl = HTMLElement & { webkitRequestFullscreen?(): Promise<void> | void };

/**
 * The element Fullscreen API on `el` (pass the element from a callback ref). The element itself goes fullscreen, so
 * nothing inside it moves or reloads. `supported` is false where element fullscreen is missing (iPhone Safari) and
 * inside a Document PiP window (its document cannot go fullscreen).
 */
export function useElementFullscreen(el: HTMLElement | null) {
  const [on, setOn] = useState(false);
  const [supported, setSupported] = useState(false);
  useEffect(() => {
    const e = el as FsEl | null;
    if (!e) return;
    const doc = e.ownerDocument as FsDoc;
    setSupported(doc === document && (typeof e.requestFullscreen === "function" || typeof e.webkitRequestFullscreen === "function"));
    const sync = () => setOn((doc.fullscreenElement ?? doc.webkitFullscreenElement ?? null) === e);
    sync();
    doc.addEventListener("fullscreenchange", sync);
    doc.addEventListener("webkitfullscreenchange", sync);
    return () => {
      doc.removeEventListener("fullscreenchange", sync);
      doc.removeEventListener("webkitfullscreenchange", sync);
    };
  }, [el]);
  const ignore = (r: unknown) => void (r as Promise<void> | undefined)?.catch?.(() => {});
  const exit = () => {
    const doc = el?.ownerDocument as FsDoc | undefined;
    if (!doc || (doc.fullscreenElement ?? doc.webkitFullscreenElement ?? null) !== el) return;
    ignore(doc.exitFullscreen ? doc.exitFullscreen() : doc.webkitExitFullscreen?.());
  };
  const toggle = () => {
    const e = el as FsEl | null;
    if (!e) return;
    if (on) exit();
    else ignore(e.requestFullscreen ? e.requestFullscreen() : e.webkitRequestFullscreen?.());
  };
  return { on, supported, toggle, exit };
}
